/**
 * Defines the contract event which the receiver of the derivative is entitled to the dividend.
 * tag: 42246
 * @readonly
 * @enum {number} (int)
 */
export enum DividendEntitlementEvent {
  ExDate = 0,
  RecordDate = 1,
}
